import styled from 'styled-components';

import { IUpsellContainer } from './types';

export const UpsellContainer = styled.div<IUpsellContainer>`
  overflow: auto;
`;
